module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty_msg":"You\u0027re all caught up!"},"es":{"empty_msg":"¡Estás al día!"}}')
  delete Component.options._Ctor
}
